import React from 'react';
import { CustomerTable } from '@app/components/tables/BasicTable/CustomerTable';
import * as S from '@app/components/tables/Tables/Tables.styles';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { PlusOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';

const CustomerTablePage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handlebtnClick = () => {
    navigate('/customers');
  };

  return (
    <>
      <PageTitle>{t('Customers')}</PageTitle>
      <Space style={{ marginBottom: '16px', justifyContent: 'space-between', width: '100%' }}>
        <BaseButton icon={<PlusOutlined />} type="primary" onClick={handlebtnClick}>
          {t('Add Customer')}
        </BaseButton>
        {/* <BaseInput
          prefix={<SearchOutlined />}
          placeholder={t('Search Users')}
          value={searchValue}
          onChange={(e) => handleSearchText(e.target.value)}
        /> */}
      </Space>
      
        <CustomerTable />
    </>
  );
};

export default CustomerTablePage;
